import { useQueryClient } from "@tanstack/react-query";
import type { GroupBase, OptionsOrGroups } from "react-select";
import type {
  OptionType,
  LoadOptionsConfig,
} from "@/types/common/load-options-types";

export const useLoadOptions = <TParams, TItem>(
  config: LoadOptionsConfig<TParams, TItem>
) => {
  const queryClient = useQueryClient();

  return async (
    search: string,
    prevOptions: OptionsOrGroups<OptionType, GroupBase<OptionType>>
  ) => {
    const pageSize = config.pageSize ?? 15;
    const page = Math.floor(prevOptions.length / pageSize);
    const params = config.getParams(search, page, pageSize);

    const response = await queryClient.fetchQuery({
      queryKey: config.queryConfig.queryKey(params),
      queryFn: () => config.queryConfig.queryFn(params),
    });

    const options: OptionType[] = response.items.map(config.mapToOption);
    const hasMore = page < response.pages - 1; // 0-based comparison

    return {
      options,
      hasMore,
    };
  };
};
